module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-Bold.73b2bf86.otf";